module.exports = __webpack_public_path__ + "img/20180815_154807_248.5dd20839.jpg";